import { FC } from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import type { MessageNavigationDialogVariant } from '../../store/messageNavigationDialog/actions'

export function toAbsoluteAppUrl(path: string): string {
  if (!path) return ''
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${window.location.origin}${normalized}`
}

export interface MessageNavigationDialogProps {
  open: boolean
  message: string
  variant: MessageNavigationDialogVariant
  path: string
  actionTitle: string
  onClose: () => void
  onConfirm: () => void
}

export const MessageNavigationDialog: FC<MessageNavigationDialogProps> = ({
  open,
  message,
  variant,
  path,
  actionTitle,
  onClose,
  onConfirm,
}) => {
  const canNavigate = Boolean(path.trim())

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {variant === 'success' ? 'Success' : 'Notice'}
      </DialogTitle>
      <DialogContent>
        <Alert severity={variant} sx={{ mt: 0.5 }}>
          {message}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={!canNavigate}
        >
          {actionTitle}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
